
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[home]",
      function () {
        return require("private-next-pages/case-studies/[home]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/[home]"])
      });
    }
  